import { Suspense } from "react";
import { Await } from "react-router";
import Heading from "~/components/lib/Heading";
import type { BlogComment } from "~/entities/blog/types";
import Comment from "./Comment";
import CommentForm from "./CommentForm";
import "./style.css";

type Props = {
  comments: Promise<BlogComment[]>;
};

const Comments: React.FC<Props> = ({ comments }) => (
  <section
    aria-label="Comments"
    className="blog-comments"
  >
    <Suspense>
      <Await
        resolve={comments}
        errorElement={null}
      >
        {(resolvedComments) =>
          resolvedComments.length > 0 && (
            <>
              <Heading
                element="h4"
                className="blog-comments__heading"
              >
                Comments
              </Heading>
              {resolvedComments.map((comment) => (
                <Comment
                  key={comment.id}
                  comment={comment}
                />
              ))}
            </>
          )
        }
      </Await>
    </Suspense>

    <Heading
      element="h4"
      className="blog-comments__heading"
    >
      Leave a Comment
    </Heading>
    <CommentForm />
  </section>
);

export default Comments;
